import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_CHECK_IN = ROUTE_PATH_ADMIN + '/checkin';
